function sakuraFall() {
  // VARS
  //////////////////////////////////
  var
  $win = $(window),
  $doc = $(document);

  var srcPath = $('script[src$="js/plugins.js"]').attr('src').split('js/').shift();
  var imgPath = srcPath + 'img/common/spacer.gif';

  //SNOWFALL
  //////////////////////////////
  var frakes = 48;

  $('#sakura').snowfall({
        flakeCount : frakes,
        flakeColor : '',
        flakeIndex : "999",
        minSize : 6,
        maxSize : 20,
        minSpeed : 1,
        maxSpeed : 2,
        round : false,
        shadow : false,
        image : imgPath
  }).fadeIn(800);
}


$(function(){

  if ($('body').hasClass('lowerpage')) {
    sakuraFall();
  }

});


